<template>
  <div class="exhibitorInquiry">
    <div class="title">
      <span>当前位置：&nbsp;</span>
      <span>展会</span>
      <span>></span>
      <span>展商中心</span>
      <span style="margin: 0 9px">></span>
      <span>展商查询</span>
    </div>
    <div class="content">
      <div class="tjqy">
        <div class="_title">
          <div class="title_">
            <div>推荐企业</div>
            <p class="line"></p>
          </div>
        </div>
        <div class="exhibits">
          <el-row :gutter="15" type="flex">
            <el-col
              :span="8"
              v-for="(item, index) in enterpriseList.slice(
                (pageIndex - 1) * pageSize,
                pageIndex * pageSize
              )"
              :key="index"
            >
              <div class="exhibit_event" @click="goExhibitorHome(item.id)">
                <p class="img_p">
                  <img :src="$getSrc(item.cLogo)" alt />
                </p>
                <p class="text_p">{{ item.cName }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="btns">
          <el-button
            class="jtbtn"
            :class="{ iconColor: exhibitorIconColorPrev }"
            :disabled="exhibitorIconColorPrevDisabled"
            @click="prev"
          >
            <i class="el-icon-caret-top"></i>
          </el-button>
          <el-button
            class="jtbtn"
            :class="{ iconColor: exhibitorIconColorNext }"
            :disabled="exhibitorIconColorNextDisabled"
            @click="next"
            style="margin: 10px 0 20px 0"
          >
            <i class="el-icon-caret-bottom"></i>
          </el-button>
          <el-button class="allbtn" @click="allProduct">更多</el-button>
        </div>
      </div>
      <div class="tjcp">
        <div class="_title">
          <div class="title_">
            <div>推荐产品</div>
            <p class="line"></p>
          </div>
        </div>

        <div class="product">
          <el-row :gutter="15" type="flex">
            <el-col
              :span="6"
              v-for="(item, index) in productList.slice(
                (pageIndex2 - 1) * pageSize2,
                pageIndex2 * pageSize2
              )"
              :key="index"
            >
              <div
                class="product_event"
                @click="goExhibitorHome(item.accountId)"
              >
                <p class="img_p">
                  <img :src="$getSrc(item.image)" alt />
                </p>
                <p class="text_p">{{ item.title }}</p>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="btns">
          <el-button
            class="jtbtn"
            :class="{ iconColor: productIconColorPrev }"
            :disabled="productIconColorPrevDisabled"
            @click="prevProduct"
          >
            <i class="el-icon-caret-top"></i>
          </el-button>
          <el-button
            class="jtbtn"
            :class="{ iconColor: productIconColorNext }"
            :disabled="productIconColorNextDisabled"
            @click="nextProduct"
            style="margin: 10px 0 20px 0"
          >
            <i class="el-icon-caret-bottom"></i>
          </el-button>
          <el-button class="allbtn" @click="allProduct">更多</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      pageSize: 6,
      pageSize2: 16,
      pageIndex: 1,
      pageIndex2: 1,
      totalSize: undefined,
      totalSize2: undefined,
      enterpriseList: [],
      productList: [],
      exhibitorIconColorPrev: false,
      exhibitorIconColorNext: true,
      exhibitorIconColorPrevDisabled: true,
      exhibitorIconColorNextDisabled: false,
      productIconColorPrev: false,
      productIconColorNext: true,
      productIconColorPrevDisabled: true,
      productIconColorNextDisabled: false,
    };
  },
  mounted() {
    this.iconColor = this.pageIndex < this.totalSize ? true : false;
    this.getAllProductAndAccount();
  },
  methods: {
    detail(id) {
      // this.eventId = id;
    },

    // 展商主页
    goExhibitorHome(id) {
      this.$http({
        url: "getAccountIndex",
        method: "post",
        params: {
          accountId: id,
        },
      }).then(({ data }) => {
        if (data.code === 0) {
          this.$router.push({
            path: "/exhibitorHome",
            query:{
              id: id
            }
          });
        } else {
          this.$message.error("当前展商不存在");
        }
      });
    },

    getAllProductAndAccount() {
      this.$http({
        url: "getAllAccount",
        method: "get",
      })
        .then(({ data }) => {
          let { code, accountEntities } = data;
          if (code === 0) {
            if (accountEntities.length <= this.pageSize) {
              this.exhibitorIconColorNextDisabled = true;
              this.exhibitorIconColorNext = false;
            }
            this.enterpriseList = accountEntities;
            this.totalSize = Math.ceil(accountEntities.length / this.pageSize);
          }
        })
        .catch((err) => console.log(err));
      this.$http({
        url: "getAllProduct",
        method: "get",
      })
        .then(({ data }) => {
          let { code, productList } = data;
          if (code === 0) {
            if (productList.length <= this.pageSize2) {
              this.productIconColorNextDisabled = true;
              this.productIconColorNext = false;
            }
            this.productList = productList;
            this.totalSize2 = Math.ceil(productList.length / this.pageSize2);
          }
        })
        .catch((err) => console.log(err));
    },

    prev() {
      this.pageIndex -= 1;
      if (this.pageIndex > 1) {
        this.exhibitorIconColorNext = true;
        this.exhibitorIconColorPrev = true;
        this.exhibitorIconColorPrevDisabled = false;
        this.exhibitorIconColorNextDisabled = false;
      } else {
        this.pageIndex = 1;
        this.exhibitorIconColorNext = true;
        this.exhibitorIconColorPrev = false;
        this.exhibitorIconColorPrevDisabled = true;
        this.exhibitorIconColorNextDisabled = false;
      }
    },
    next() {
      this.pageIndex += 1;
      if (this.pageIndex > 1 && this.pageIndex < this.totalSize) {
        this.exhibitorIconColorNext = true;
        this.exhibitorIconColorPrev = true;
        this.exhibitorIconColorPrevDisabled = false;
      } else {
        this.pageIndex = this.totalSize;
        this.exhibitorIconColorNext = false;
        this.exhibitorIconColorPrev = true;
        this.exhibitorIconColorNextDisabled = true;
        this.exhibitorIconColorPrevDisabled = false;
      }
    },
    prevProduct() {
      this.pageIndex2 -= 1;
      if (this.pageIndex2 > 1) {
        this.productIconColorNext = true;
        this.productIconColorPrev = true;
        this.productIconColorPrevDisabled = false;
        this.productIconColorNextDisabled = false;
      } else {
        this.pageIndex2 = 1;
        this.productIconColorNext = true;
        this.productIconColorPrev = false;
        this.productIconColorPrevDisabled = true;
        this.productIconColorNextDisabled = false;
      }
    },
    nextProduct() {
      this.pageIndex2 += 1;
      if (this.pageIndex2 > 1 && this.pageIndex2 < this.totalSize2) {
        this.productIconColorNext = true;
        this.productIconColorPrev = true;
        this.productIconColorPrevDisabled = false;
      } else {
        this.pageIndex2 = this.totalSize2;
        this.productIconColorNext = false;
        this.productIconColorPrev = true;
        this.productIconColorPrevDisabled = false;
        this.productIconColorNextDisabled = true;
      }
    },
    allProduct() {
      this.$emit("switchCloudShow", true);
      // this.$router.push({
      //   path: "/cloudExhibition"
      // })
    },
  },
};
</script>
<style lang="scss">
.exhibitorInquiry {
}
</style>
<style lang="scss" scoped>
.exhibitorInquiry {
  .iconColor {
    color: #143277 !important;
  }
  min-height: 1177px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 110px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 9px;
    }
  }
  .content {
    width: 857px;
    margin: 10px auto 21px;
    ._title {
      height: 55px;
      font-size: 22px;
      line-height: 22px;
      margin-top: 30px;
      .line {
        width: 36px;
        height: 2px;
        background-color: #d71b1c;
        margin: 10px 0 21px 0;
      }
      .title_ {
        width: 90px;
        float: left;
        font-weight: bold;
      }
      .all {
        font-size: 14px;
        color: #646464;
        width: 90px;
        float: right;
        margin-right: 14px;
        img {
          margin-left: 7px;
        }
      }
    }
    .el-row {
      flex-wrap: wrap;
    }
    .el-col {
      margin-top: 14px;
    }
    .tjqy {
      position: relative;
      min-height: 180px;
      .exhibits {
        width: 802px;
        .exhibit_event {
          width: 256px;
          height: 109px;
          border: 1px solid #f3f3f3;
          border-radius: 10px;
          cursor: pointer;
          .img_p {
            width: 210px;
            height: 58px;
            margin: 10px auto 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              display: inline-block;
              vertical-align: middle;
            }
          }
          .text_p {
            width: 210px;
            height: 16px;
            line-height: 16px;
            color: #333333;
            margin: 0 auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .btns {
        top: 68px;
        right: -22px;
      }
    }
    .btns {
      position: absolute;
      .el-button {
        display: block;
        margin: 0;
        border: 1px solid #e5e5e5;
        line-height: 0;
        border-radius: 2px;
        &:hover,
        &:focus {
          background-color: #ffffff;
          border-color: #e5e5e5;
        }
      }
      .jtbtn {
        width: 38px;
        height: 38px;
        color: #c7c7c7;
        padding-left: 12px;
      }
      .allbtn {
        width: 58px;
        height: 32px;
        color: #333333;
        font-size: 14px;
        padding-left: 15px;
        &:hover {
          color: #333333;
        }
      }
    }
    .tjcp {
      position: relative;
      min-height: 319px;
      margin-top: 60px;
      .btns {
        top: 70px;
        right: -22px;
      }
      .product {
        padding-bottom: 60px;
        width: 802px;
      }
      .product_event {
        width: 188px;
        height: 188px;
        border: 1px solid #f3f3f3;
        border-radius: 10px;
        cursor: pointer;
      }
      .img_p {
        width: 162px;
        height: 108px;
        margin: 13px 14px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
          display: inline-block;
          vertical-align: middle;
        }
      }
      .text_p {
        font-size: 16px;
        color: #333333;
        width: 162px;
        margin: 12px 0 0 14px;
        line-height: 23px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
}
</style>